// ==================== USE LEAD GEN EVENTS HOOK ====================
// Subscribes to real-time Lead Generation agent events (leadgen:*) pushed over
// Socket.IO. Use it to auto-refresh analytics / discovery / pipeline views as
// the agent works in the background.

import { useEffect, useRef } from 'react';
import { websocketService, type LeadGenEventPayload } from '../services/websocket.service';

interface UseLeadGenEventsOptions {
  /** Called for every leadgen:* event. */
  onEvent?: (event: LeadGenEventPayload) => void;
  /** Only fire onEvent for these event types (e.g. ['lead.discovered', 'run.completed']). */
  events?: string[];
  /** Auto-connect the socket on mount (default true). */
  autoConnect?: boolean;
}

export function useLeadGenEvents({ onEvent, events, autoConnect = true }: UseLeadGenEventsOptions) {
  // Keep the latest callback without re-subscribing on every render.
  const handlerRef = useRef(onEvent);
  handlerRef.current = onEvent;
  const filterRef = useRef(events);
  filterRef.current = events;

  useEffect(() => {
    if (autoConnect) websocketService.connect();

    const unsubscribe = websocketService.onLeadGenEvent((event) => {
      const filter = filterRef.current;
      if (filter && filter.length > 0 && !filter.includes(event.event)) return;
      handlerRef.current?.(event);
    });

    return unsubscribe;
  }, [autoConnect]);
}

export default useLeadGenEvents;
